import {api} from '../_support/api';
import state from './state';

export default api({
  baseUrl: state.api.baseUrl,
  consumerKey: state.api.consumerKey,
});
